import React, { useEffect, useRef, useState } from 'react';
import './CustomDropdown.css';

// Generic, styled dropdown not relying on native <select>
// Props:
// - options: [{ value, label }]
// - value: current value
// - onChange: (value) => void
// - placeholder: string
// - className: optional extra class for container
const CustomDropdown = ({ options = [], value = null, onChange, placeholder = 'Не выбрано', className = '' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selected = options.find((o) => `${o.value}` === `${value}`) || null;

  const handleSelect = (val) => {
    if (onChange) onChange(val);
    setOpen(false);
  };

  return (
    <div className={`custom-dropdown ${className}`} ref={ref}>
      <div
        className="custom-dropdown__control"
        role="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className={!selected ? 'custom-dropdown__placeholder' : ''}>
          {selected ? selected.label : placeholder}
        </span>
        <i className={`custom-dropdown__chevron ${open ? 'up' : 'down'}`} />
      </div>
      {open && (
        <div className="custom-dropdown__menu" role="listbox">
          {options.map((opt) => (
            <div
              key={opt.value}
              role="option"
              aria-selected={`${opt.value}` === `${value}`}
              className="custom-dropdown__option"
              onClick={() => handleSelect(opt.value)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;

